import { useState, useEffect } from 'react';
import { useModel } from '@src/generic/model-store';
import ElementEventListener from './ElementEventListener';

import { getCookies, handleCorrelationIDCookie } from './utils';

const CohesionWrapper = () => {
  const selectors = [
    '#course-celebration-cert-button',
    '#celebration-footnote-wrapper #upgrade-link',
    '#courseHome-dates #date-verified-upgrade-deadline',
    '#grade-course-header #upgrade-button',
    '#upgrade-shift-dates-alert',
    '#upgrade-complete-alert',
  ];
  const [isLoaded, setLoaded] = useState(false);
  window.chsn_pageType = 'lms-course';
  const courseId = window.location.pathname.split('/')[2];

  const {
    org,
    title,
  } = useModel('courseHomeMeta', courseId);

  const data = {
    tglrCorrelationId: getCookies()?.tglr_correlation_id,
    org: org?.toLowerCase(),
    courseName: title,
  };

  selectors.forEach((selector) => {
    ElementEventListener(selector, 'click', data);
  });

  useEffect(() => {
    if (isLoaded) {
      return;
    }

    const head = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.src = 'https://www.edx.org/beam-wrapper.js';
    script.defer = true;
    script.dataset.testId = 'cohesion-test';
    head.appendChild(script);
    setLoaded(true);
    handleCorrelationIDCookie();
  }, [isLoaded]);

  return null;
};

export default CohesionWrapper;
